// DataTable.jsx
import React, { ReactElement, useRef, useState } from 'react';

import {
  Button,
  Cascader,
  DatePicker,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  TreeSelect,
  Row, Col,
  Flex,
  Checkbox,
  message
} from 'antd';
import PersianDatePicker from '../Calendar/PersianDatePicker';
import { Morakasi } from '../../Model/dbo/Morakasi';
import { ADDMorakasiForUser } from '../../RestAPI/dbo/Morakasiapi';
import { DateObject } from 'react-multi-date-picker';
import { DateType } from 'react-date-object';
import DropdownButton from 'antd/es/dropdown/dropdown-button';
import type { TimePickerProps } from 'antd';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { RadiusBottomrightOutlined, SaveOutlined } from '@ant-design/icons';


type SizeType = Parameters<typeof Form>[0]['size'];

export default function NewMorkasi(props: any) {

  const [edateKey, setEdateKey] = useState(1.1)
  const [sdateKey, setSdateKey] = useState(1.2)
  const [formData, setFormData] = useState({
    sdate: "",
    edate: "",
    stime: dayjs('00:00:00', 'HH:mm:ss'),
    etime: dayjs('00:00:00', 'HH:mm:ss'),
    issaati: false
  });

  const [model, setModel] = useState<Morakasi>({
    ID: 0,
    UserSave: 0,
    UserConfirm: 0,
    SaveDate: '',
    Date: '',
    ConfirmDate: '',
    PersonelID: 0,
    FullName: '',
    Status: '',
    IsPast: false,
    MForced: false,
    StartTime: '',
    EndTime: '',
    Day: 0
  });

  const saveMorakasi = async (startDate: string, endDate: string, start: string, end: string) => {

    console.log("sa1111a")
    const success = await ADDMorakasiForUser(startDate, endDate, start, end);
    console.log(success)
    if (success) {
      message.success("درخواست با موفقیت ثبت شد");
      setFormData({
        sdate: "",
        edate: "",
        stime: dayjs('00:00:00', 'HH:mm:ss'),
        etime: dayjs('00:00:00', 'HH:mm:ss'),
        issaati: false
      });

      console.log("saa")
      setIsEnabled(false);
      props.loadList();
      // window.location.reload();
      console.log("sa222a")
      setMorakhasisDate('');
      setMorakhasieDate('');
      setstarttime('');
      setendtime('');
    }
  };
  async function addmorakasi() {

    if ((morakhasisDate != '' && morakhasieDate != '') || (morakhasisDate != '' && startTime != '' && endtime != '')) {
      if (morakhasieDate == '') {
        saveMorakasi(morakhasisDate, morakhasisDate, startTime, endtime);
        props.loadList();
        setIsEnabled(false);
      }
      else {
        saveMorakasi(morakhasisDate, morakhasieDate, startTime, endtime);
        props.loadList();
        setIsEnabled(false);
      }
      setSdateKey(sdateKey * 1.1);
      setEdateKey(edateKey * 1.1);
    }
    else {
      message.success("لطفا فیلدهای ضروری را پر کنید");
    }


  }
  const onChange: TimePickerProps['onChange'] = (time, timeString) => {
    console.log(time, timeString);
    setFormData((prev) => ({ ...prev, stime: time }));
    setstarttime((time.hour().toString().length < 2 ? '0' + time.hour().toString() : time.hour().toString())
      + (time.minute().toString().length < 2 ? '0' + time.minute().toString() : time.minute().toString()));
  };
  const onChange1: TimePickerProps['onChange'] = (time, timeString) => {
    setFormData((prev) => ({ ...prev, etime: time }));
    console.log(time.hour().toString() + time.minute().toString());
    setendtime((time.hour().toString().length < 2 ? '0' + time.hour().toString() : time.hour().toString())
      + (time.minute().toString().length < 2 ? '0' + time.minute().toString() : time.minute().toString()));

  };
  const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
  const [morakhasisDate, setMorakhasisDate] = useState<string>('');
  const [morakhasieDate, setMorakhasieDate] = useState<string>('');
  const [startTime, setstarttime] = useState<string>('');
  const [endtime, setendtime] = useState<string>('');
  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };
  const [value, setValue] = useState(1);
  const [isEnabled, setIsEnabled] = useState(false);


  const handleRadioChange = (event: any) => {
    setIsEnabled(event.target.checked);

    // اگر گزینه "فعال" انتخاب شده باشد، isEnabled را true می‌کنیم
  };


  return (
    <>
      <Form
        initialValues={{ size: componentSize }}
        onValuesChange={onFormLayoutChange}
        size={componentSize as SizeType}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={6}>

            <Checkbox checked={isEnabled} value={formData.issaati} onChange={handleRadioChange} >مرخصی ساعتی </Checkbox>

          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={6}>
            <Form.Item rules={[{ required: true, message: "لطفاً تاریخ انتخاب کنید!" }]} label="مرخصی از تاریخ :"  >
              <PersianDatePicker key={sdateKey} value={formData.sdate} setMorakhasiDate={setMorakhasisDate}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={6}>
            <Form.Item label="مرخصی تا تاریخ :"  >
              <PersianDatePicker key={edateKey} value={formData.edate} disabled={isEnabled} setMorakhasiDate={setMorakhasieDate}
              />
            </Form.Item>
          </Col>

        </Row>
        <Row>
          <Col xs={24} sm={6}>
            <Form.Item label="ساعت شروع :"  >
              <TimePicker disabled={!isEnabled} value={formData.stime} onChange={onChange} defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={6}>
            <Form.Item label="ساعت پایان :" >
              <TimePicker disabled={!isEnabled} value={formData.etime} onChange={onChange1} defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')} />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ direction: "ltr" }}>

          <Form.Item  >
            <Button style={{ marginRight: 5 }} color='danger' variant="solid" icon={<SaveOutlined />} onClick={addmorakasi}>ثبت درخواست</Button>
          </Form.Item>
          <Form.Item >
            <Button>انصراف</Button>
          </Form.Item>
        </Row>
      </Form>
    </>

  );
};



